import React from "react";
import "./App.css";
import { Landing } from "./components/Landing";
import {
  BrowserRouter,
  Routes,
  Route,
  Redirect,
  useHistory,
  useNavigate,
} from "react-router-dom";
import StatusCheck from "./components/StatusCheck";
import Home from "./components/pages/Home";
import Profile from "./components/pages/Profile";
import { app } from "./firebase";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import rootReducer from "./redux/reducers";
import thunk from "redux-thunk";

import {
  getDatabase,
  ref,
  onValue,
  push,
  onDisconnect,
  set,
  serverTimestamp,
} from "firebase/database";
import Market from "./components/Activity/Market";
import Menu from "./components/pages/Menu";
import SideBar from "./components/pages/Sidebar";
import VisitProfile from "./components/products/VisitProfile";

function App() {
  const [user, setUser] = React.useState();
  const [load, setload] = React.useState(false);

  const store = createStore(rootReducer, applyMiddleware(thunk));
  const [isConnected, setIsConnected] = React.useState(false);
  React.useEffect(() => {
    onAuthStateChanged(getAuth(app), (user) => {
      setload(true);
      setUser(user);
      if (user !== null) {
        connect();
      }
    });
  });

  const signed = () => {
    const auth = getAuth();
    onAuthStateChanged(getAuth(app), (user) => {
      if (user) {
        setUser(true);
        console.log(user);
      } else {
        setUser(false);
      }
    });
  };

  var connect = () => {
    const db = getDatabase();
    var myConnectionsRef = ref(db, `users/${getAuth().currentUser.uid}`);

    // stores the timestamp of my last disconnect (the last time I was seen online)
    var lastOnlineRef = ref(
      db,
      `users/${getAuth().currentUser.uid}/lastOnline`
    );

    var connectedRef = ref(db, ".info/connected");
    onValue(connectedRef, (snap) => {
      if (snap.val() === true) {
        // We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)
        const con = push(myConnectionsRef);

        // When I disconnect, remove this device
        onDisconnect(con).remove();

        // Add this device to my connections list
        // this value could contain info about the device or a timestamp too
        set(con, true);

        // When I disconnect, update the last time I was seen online
        onDisconnect(lastOnlineRef).set(serverTimestamp());
        console.log("connected");
        setIsConnected(true);
      } else {
        console.log("not connected");
        setIsConnected(false);
      }
    });
  };

  if (user) {
    return (
      <div className="flex flex-col lg:flex-row lg:justify-between w-full h-screen">
        <Menu />
        <div className="overflow-auto w-full">
          {isConnected === false ? (
            <div className="bg-red-300 p-1 md:p-2 rounded-md">
              <p className="text-red-600 text-xs md:text-sm">
                {" "}
                not connected, it will automatically in a few seconds connect
                once there is internet (one of our security measures to keep
                your activity safe)
              </p>{" "}
            </div>
          ) : null}
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/landing" element={<Landing />} /> */}

            <Route path="/profile" element={<Profile />} />
            <Route path="/market" element={<Market />} />
            <Route path="/vprofile" element={<VisitProfile />} />
          </Routes>
        </div>

        <div className="w-40">
          <SideBar />
        </div>
      </div>
    );
  } else if (user === null && load === true) {
    return (
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    );
  }
  return <div>Loading</div>;
}

export default App;
